/* Lafantar: colour swatches on cards, per-colour gallery filtering,
   'pick your size' prompt and the prepaid-offer banner on the product page. */
(function () {
  if (window.__lfVariants) return;
  window.__lfVariants = true;

  function clean(s) {
    return (s == null ? '' : String(s)).toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  /* ---------- Collection cards: preview a colour on hover ---------- */
  function cardImg(card) {
    return card && card.querySelector('.card__media .media img');
  }

  function swapCard(sw) {
    var card = sw.closest('.card-wrapper');
    var img = cardImg(card);
    if (!img || !sw.dataset.src) return;
    if (!img.hasAttribute('data-lf-orig-src')) {
      img.setAttribute('data-lf-orig-src', img.getAttribute('src') || '');
      img.setAttribute('data-lf-orig-srcset', img.getAttribute('srcset') || '');
    }
    img.setAttribute('srcset', sw.dataset.srcset || '');
    img.setAttribute('src', sw.dataset.src);
    card.classList.add('lf-swatch-active');
    card.querySelectorAll('.lf-card-swatch').forEach(function (s) {
      s.classList.toggle('is-active', s === sw);
    });
  }

  function restoreCard(card) {
    if (!card) return;
    var img = cardImg(card);
    if (img && img.hasAttribute('data-lf-orig-src')) {
      img.setAttribute('srcset', img.getAttribute('data-lf-orig-srcset'));
      img.setAttribute('src', img.getAttribute('data-lf-orig-src'));
    }
    card.classList.remove('lf-swatch-active');
    card.querySelectorAll('.lf-card-swatch.is-active').forEach(function (s) {
      s.classList.remove('is-active');
    });
  }

  if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', function (e) {
      var sw = e.target.closest && e.target.closest('.lf-card-swatch[data-src]');
      if (sw) swapCard(sw);
    });
    document.addEventListener('mouseout', function (e) {
      var box = e.target.closest && e.target.closest('[data-lf-card-swatches]');
      if (!box) return;
      if (e.relatedTarget && box.contains(e.relatedTarget)) return;
      restoreCard(box.closest('.card-wrapper'));
    });
  }

  /* ---------- Product page: colour -> media map ---------- */
  var cache = {};
  var active = {};
  var pendingShake = {};
  var picked = {};

  function readData(sid) {
    var el = document.getElementById('lf-variant-media-' + sid);
    if (!el) return null;
    if (cache[sid] && cache[sid].el === el) return cache[sid];
    var data;
    try {
      data = JSON.parse(el.textContent);
    } catch (err) {
      return null;
    }
    var names = data.colors.map(function (c) { return clean(c.name); });
    var byFeatured = {};
    data.colors.forEach(function (c, i) {
      if (c.featured != null) byFeatured[String(c.featured)] = names[i];
    });
    var map = {};
    var current = '';
    data.media.forEach(function (m) {
      var id = String(m.id);
      var alt = clean(m.alt);
      var col = '';
      if (alt && names.indexOf(alt) > -1) {
        col = alt;
      } else if (byFeatured[id]) {
        col = byFeatured[id];
      } else if (alt) {
        for (var i = 0; i < names.length; i++) {
          if ((' ' + alt + ' ').indexOf(' ' + names[i] + ' ') > -1) {
            col = names[i];
            break;
          }
        }
      } else {
        col = current; /* untagged photo: belongs to the colour before it */
      }
      if (col) current = col;
      map[id] = col; /* '' = shared photo, always shown */
    });
    cache[sid] = { el: el, map: map };
    return cache[sid];
  }

  function idFrom(str, sid) {
    var p = sid + '-';
    return str && str.indexOf(p) === 0 ? str.slice(p.length) : str;
  }

  function applyFilter(sid, colorValue) {
    var d = readData(sid);
    if (!d) return;
    var color = clean(colorValue);
    var hasPhotos = Object.keys(d.map).some(function (k) { return d.map[k] === color; });
    function hide(id) {
      if (!hasPhotos) return false;
      var c = d.map[id];
      return !!c && c !== color;
    }
    var gallery = document.getElementById('MediaGallery-' + sid);
    if (gallery) {
      gallery.querySelectorAll('li[data-media-id]').forEach(function (li) {
        li.classList.toggle('lf-media-hidden', hide(idFrom(li.dataset.mediaId, sid)));
      });
      gallery.querySelectorAll('li[data-target]').forEach(function (li) {
        li.classList.toggle('lf-media-hidden', hide(idFrom(li.dataset.target, sid)));
      });
      var viewer = document.getElementById('GalleryViewer-' + sid);
      if (viewer) {
        if (viewer.slider) viewer.slider.scrollLeft = 0;
        if (typeof viewer.resetPages === 'function') viewer.resetPages();
      }
      var thumbs = document.getElementById('GalleryThumbnails-' + sid);
      if (thumbs && typeof thumbs.resetPages === 'function') thumbs.resetPages();
    }
    var modal = document.getElementById('ProductModal-' + sid);
    if (modal) {
      modal.querySelectorAll('[data-media-id]').forEach(function (el) {
        el.classList.toggle('lf-media-hidden', hide(idFrom(el.dataset.mediaId, sid)));
      });
    }
  }

  function selectedColor(sid) {
    var vs = document.getElementById('variant-selects-' + sid);
    var input = vs && vs.querySelector('[data-lf-color-option] input:checked');
    return input ? input.value : null;
  }

  /* ---------- Size: shake, 'please select', must be picked before buying ---------- */
  function sizeField(sid) {
    var vs = document.getElementById('variant-selects-' + sid);
    if (!vs) return null;
    return vs.querySelector('[data-lf-size-option]') || vs.querySelector('.product-form__input:not([data-lf-color-option])');
  }

  function hasRadioSize(sid) {
    var f = sizeField(sid);
    return !!(f && f.querySelector('input[type=radio]'));
  }

  function infoEl(sid) {
    var vs = document.getElementById('variant-selects-' + sid);
    return vs && vs.closest('product-info');
  }

  function showBanner(sid) {
    var b = document.getElementById('lf-prepaid-' + sid);
    if (b && b.hidden) {
      b.hidden = false;
      b.classList.add('lf-prepaid-banner--in');
    }
  }

  function markPicked(sid) {
    picked[sid] = true;
    pendingShake[sid] = false;
    var pi = infoEl(sid);
    if (pi) pi.setAttribute('data-lf-size-picked', '');
    var f = sizeField(sid);
    var hint = f && f.querySelector('.lf-size-hint');
    if (hint) hint.remove();
    showBanner(sid);
  }

  function showHint(sid) {
    var f = sizeField(sid);
    if (!f || f.querySelector('.lf-size-hint')) return;
    var p = document.createElement('p');
    p.className = 'lf-size-hint';
    p.setAttribute('role', 'alert');
    p.textContent = 'Please select your size';
    f.appendChild(p);
  }

  function shakeSize(sid) {
    var f = sizeField(sid);
    if (!f) return;
    f.classList.remove('lf-shake', 'lf-attn');
    void f.offsetWidth;
    f.classList.add('lf-shake', 'lf-attn');
    var r = f.getBoundingClientRect();
    if (r.top < 0 || r.bottom > window.innerHeight) {
      f.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    setTimeout(function () { f.classList.remove('lf-shake'); }, 700);
    setTimeout(function () { f.classList.remove('lf-attn'); }, 1800);
  }

  function flushShake(sid) {
    if (!pendingShake[sid]) return;
    pendingShake[sid] = false;
    shakeSize(sid);
  }

  /* Colour picked: filter photos now; if no size chosen yet, shake once the picker refreshes */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.closest) return;
    var vs = input.closest('variant-selects');
    if (!vs) return;
    var sid = vs.dataset.section;
    if (input.closest('[data-lf-size-option]')) {
      markPicked(sid);
      return;
    }
    if (!input.closest('[data-lf-color-option]')) return;
    active[sid] = true;
    applyFilter(sid, input.value);
    if (!picked[sid]) {
      pendingShake[sid] = true;
      setTimeout(function () { flushShake(sid); }, 1200);
    }
  });

  /* Tapping a size (even the one Shopify pre-selected) counts as choosing it.
     Add to cart / Buy now are blocked until a size is chosen. */
  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      var sizeBox = t.closest('[data-lf-size-option]');
      if (sizeBox) {
        var svs = sizeBox.closest('variant-selects');
        if (svs && (t.closest('label') || t.tagName === 'INPUT')) markPicked(svs.dataset.section);
        return;
      }

      var btn = t.closest('button, a, input[type=submit], [role=button]');
      var isBuy =
        !!t.closest('.shopify-payment-button, [class*=gokwik] button, button[class*=gokwik], [id*=gokwik] button') ||
        (btn &&
          (btn.matches('[name=add], .product-form__submit') ||
            /add to cart|buy (it )?now/i.test(btn.textContent || btn.value || '')));
      if (!isBuy) return;
      if (t.closest('.card-wrapper, product-recommendations, cart-drawer, cart-notification, .cart-drawer')) return;

      var pi = t.closest('product-info') || document.querySelector('product-info[id^=MainProduct]');
      var vs = pi && pi.querySelector('variant-selects');
      if (!vs) return;
      var sid = vs.dataset.section;
      if (picked[sid] || !hasRadioSize(sid)) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      showHint(sid);
      shakeSize(sid);
    },
    true
  );

  function onVariantChange() {
    setTimeout(function () {
      Object.keys(active).forEach(function (sid) {
        var c = selectedColor(sid);
        if (c) applyFilter(sid, c);
      });
      Object.keys(pendingShake).forEach(flushShake);
    }, 50);
  }

  function init() {
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
    }
    /* Products with no size buttons: nothing to choose, show the offer right away */
    document.querySelectorAll('variant-selects[data-section]').forEach(function (vs) {
      var sid = vs.dataset.section;
      if (!hasRadioSize(sid)) markPicked(sid);
    });
    /* Arriving with a colour already chosen (e.g. from a card swatch) */
    if (!/[?&]variant=/.test(window.location.search)) return;
    document.querySelectorAll('script[data-lf-variant-media]').forEach(function (s) {
      var sid = s.dataset.section;
      var c = selectedColor(sid);
      if (c) {
        active[sid] = true;
        applyFilter(sid, c);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
